module.exports = __webpack_public_path__ + "img/tingche_checked.8d4b86cc.png";